export default "/images/corner-left-down.svg?c3dcab52b3e8c0b4b69b318bb097371f";